import { $ } from '@starberry/components';
import { extendTheme } from '@chakra-ui/react';

import BaseDefinitions from 'base/definitions';
import sideNav from 'base/defaults/sidenav';

import CompanyLogo from './components/CompanyLogo';

export default {
  ...BaseDefinitions,
  constants: {
    ...BaseDefinitions.constants,
    'site-name': 'Martyn Gerrard',
    companyLogo: CompanyLogo,
    indexPage: 'MyPropertyPage',
    propertyPageDetails: false,
    sideNav: sideNav.filter(({ label }) =>
      ['Back to Website', 'My Property', 'Profile', 'Logout'].includes(label)
    ),
    icons: {
      ...BaseDefinitions.constants.icons,
    },
    colors: {
      primary: '#005480',
      primaryTextContrast: '#fff',
      secondary: '#B88B74',
      secondaryTextContrast: '#fff',
      tertiary: '#005480',
      tertiaryTextContrast: '#fff',
      text: '#1C1C1C',
      button: '#3D3D3D',
      buttonPressed: '#5B5A5A',
      icons: '#232125',
      grey1: '#3C3C3B',
      grey2: '#575757',
      grey3: '#DDDDDD',
      grey4: '#F6F6F5',
      grey5: '#FAFAFA',
      grey6: '#BDBDBD',
    },
    sidebarBgColor: '#005480',
    headings: {
      baseHeading: {
        color: '#232125',
      },
      headingSize: {
        h1: '4.125rem',
        h2: '3.125rem',
        h3: '2.25rem',
        h4: '1.75rem',
        h5: '1.375rem',
        h6: '1.375rem',
        text: '1rem',
      },
      headingLineHeight: {
        h1: 1.09,
        h2: 1.28,
        h3: 1.33,
        h4: 1.36,
        h5: 1.45,
        h6: 1.45,
      },
    },
  },
  theme: extendTheme({
    fonts: {
      body: '"GillSansNova", sans-serif',
      heading: '"GillSansNova", serif',
    },
    fontWeights: {
      bold: 700,
    },
  }),
  modules: {
    ...BaseDefinitions.modules,
    indexPage: 'MyPropertyPage',
    DesktopSideMenu: {
      $: BaseDefinitions.modules.DesktopSideMenu,
      logoContainerProps: {
        mb: [4, null, 16],
        w: ['146px', null, null, '132px'],
        h: 'auto',
      },
    },
    MobileSideMenu: {
      $: BaseDefinitions.modules.MobileSideMenu,
      logoContainerProps: {
        mb: [4, null, 16],
        w: ['146px', null, null, '132px'],
        h: 'auto',
      },
    },
    AccountHeader: {
      $: BaseDefinitions.modules.AccountHeader,
      props: {
        search: null,
      },
    },
    BaseButton: {
      $: BaseDefinitions.modules.BaseButton,
      props: {
        borderRadius: '4px',
        textTransform: 'uppercase',
        padding: '10px 26px',
      },
    },
    PrimaryButton: {
      $: BaseDefinitions.modules.PrimaryButton,
      color: $('constants.colors.primaryTextContrast'),
      bg: 'linear-gradient(306.96deg, #00BCE4 -7.26%, #005480 92.06%)',
      boxShadow: '0px 2px 12px rgba(0, 0, 0, 0.15)',
      _hover: {
        color: $('constants.colors.primaryTextContrast'),
        bg: 'linear-gradient(306.96deg, #00BCE4 -45.26%, #005480 92.06%)',
        boxShadow: 'none',
      },
    },
    SecondaryButton: {
      $: BaseDefinitions.modules.SecondaryButton,
      color: $('constants.colors.primaryTextContrast'),
      bg: '#B88B74',
      boxShadow: '0px 2px 12px rgba(0, 0, 0, 0.15)',
      _hover: {
        color: $('constants.colors.primaryTextContrast'),
        bg: '#B88B74',
      },
    },
    LoginForm: {
      $: BaseDefinitions.modules.LoginForm,
      props: {
        submitButton: {
          $: 'SecondaryButton',
          props: {
            type: 'submit',
          },
          children: $('constants.translations.login.LOGIN_SUBMIT_BTN', 'Continue'),
        },
      },
    },
    ForgetPassForm: {
      $: BaseDefinitions.modules.ForgetPassForm,
      props: {
        submitButton: {
          $: 'SecondaryButton',
          props: {
            type: 'submit',
          },
          children: $('constants.translations.resetPassEmail.FORGET_SUBMIT_BTN', 'Reset Password'),
        },
      },
    },
    SignUpForm: {
      $: BaseDefinitions.modules.SignUpForm,
      props: {
        submitButton: {
          $: 'SecondaryButton',
          props: {
            type: 'submit',
          },
          children: $('constants.translations.login.SIGNUP_SUBMIT_BTN', 'Continue'),
        },
      },
    },
    ResetPassForm: {
      $: BaseDefinitions.modules.ResetPassForm,
      props: {
        submitButton: {
          $: 'SecondaryButton',
          props: {
            type: 'submit',
          },
          children: $('constants.translations.resetPass.RESET_SUBMIT_BTN', 'Change Password'),
        },
      },
    },
  },
};
